import React, { Fragment } from "react";
import Starter from "../../../component/Starter";

const RegisterUser = () => {
  return (
    <Starter
      topBarTitle="Raise Ticket"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Query Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Query</a>
          </li>
          <li className="breadcrumb-item active">Raise Ticket</li>
        </Fragment>
      }
    ></Starter>
  );
};

export default RegisterUser;
